<template>
    <div class="lightboxManager">
        <slot></slot>
    </div>
</template>

<script>
import {
    addUserInteractionEvents,
    blockScroll,
    releaseScroll,
} from '../utils';

/**
    Since slot components are mounted before the lightbox manager component,
    we need to remove the empty DOM nodes when this component is mounted.
    This trick allows us to preserve the logic running inside each mounted hook in the lightbox component.
*/
export default {
    props: {
        queue: {
            type: String,
            default: ""
        },
        enableUserInteractionEvents: {
          type: Boolean,
          default: false,
        }
    },
    data() {
        return {
            nodesToRemove: [],
            unwatch: null,
        }
    },
    created() {
        // In Vue 3, $slots.default is a function that returns VNodes
        const defaultSlots = this.$slots.default ? this.$slots.default() : [];
        const templates = defaultSlots.filter(slot => slot?.type === 'div' && slot?.props?.name);

        templates.forEach((vnode) => {
            const name = vnode.props?.name;
            const nameNotRegistered = this.$store.state.ui.lightboxManager.registeredModels.indexOf(name) == -1;
            const isTemplateNotEmpty = !!(vnode?.children?.[0])

            if (isTemplateNotEmpty) {
                if (nameNotRegistered) {
                    this.$store.dispatch('ui/lightboxManager/register', name);
                }
                else {
                    console.warn(`lightbox with name:${name} already registered`);
                    this.nodesToRemove.push(vnode);
                }
            }
            else {
                this.nodesToRemove.push(vnode);
            }
        });

        //Set the enableUserInteractionEvents in the store
        this.$store.commit('ui/lightboxManager/SET_ENABLE_USER_INTERACTION_EVENTS', this.enableUserInteractionEvents);

        // Initialize the queue system
        this.$store.dispatch("ui/lightboxManager/initialize", this.queue ? this.queue.split(",").map(name => name?.trim()) : []);

        // Control the scroll block behavior when lightboxes are shown or hidden
        this.unwatch = this.$store.watch((state) => state.ui.lightboxManager.current, (newValue, _oldValue) => newValue ? blockScroll() : releaseScroll(), {immediate: true});
    },
    mounted() {
        this.nodesToRemove.forEach((vnode) => {
            // In Vue 3, the DOM element is accessed via vnode.el instead of vnode.elm
            vnode.el && vnode.el.remove();
        });

        // Ensure event listeners are attached after the page content is fully loaded:
        window.addEventListener('load', () => {
            if (this.enableUserInteractionEvents) {
              addUserInteractionEvents(() => this.$store.dispatch('ui/lightboxManager/userInteractionDetected'));
            } else {
              this.$store.dispatch('ui/lightboxManager/showLightboxAfterPageLoad');
            }
        });
    },
    beforeDestroy() {
        this.unwatch();
    },
}
</script>
